import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BaryCanonicalService {
  private router = inject(Router);
  private document = inject(DOCUMENT);
  private meta = inject(Meta);

  constructor() {
    // S'abonner aux changements de route pour mettre à jour l'URL canonique et og:url
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.router.url)
      )
      .subscribe(() => {
        this.updateCanonicalUrl();
        this.updateOgUrl();
      });
  }

  /**
   * Met à jour l'URL canonique en utilisant simplement origine + path
   */
  updateCanonicalUrl(): void {
    const host = this.document.location.hostname ?? '';
    const internalHost = host.endsWith('baryshop.com');
    const preferredOrigin = sessionStorage.getItem('preferredOrigin') ?? '';
    const path = (this.document.location.pathname ?? '/') + (this.document.location.search ?? '');
    const canonical = internalHost && preferredOrigin ? `${preferredOrigin}${path}` : this.document.location.origin + this.document.location.pathname;
    this.setCanonicalUrl(canonical);
  }

  /**
   * Synchronise la balise og:url avec l'URL courante
   */
  updateOgUrl(): void {
    const host = this.document.location.hostname ?? '';
    const internalHost = host.endsWith('baryshop.com');
    const preferredOrigin = sessionStorage.getItem('preferredOrigin') ?? '';
    const pathAndQuery = (this.document.location.pathname ?? '/') + (this.document.location.search ?? '');
    const href = internalHost && preferredOrigin ? `${preferredOrigin}${pathAndQuery}` : this.document.location.href;
    this.meta.updateTag({ property: 'og:url', content: href });
  }

  /**
   * Définit l'URL canonique dans le head du document
   */
  private setCanonicalUrl(url: string): void {
    // Rechercher la balise canonique existante
    let linkEl: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');

    if (linkEl) {
      // Mettre à jour la balise existante
      linkEl.setAttribute('href', url);
    } else {
      // Créer une nouvelle balise
      linkEl = this.document.createElement('link');
      linkEl.setAttribute('rel', 'canonical');
      linkEl.setAttribute('href', url);
      this.document.head.appendChild(linkEl);
    }
  }
}
